import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Provider } from './context';

import './style.css';

class RadioButtonGroup extends React.Component {
  constructor(props) {
    super(props);
    const { initial } = this.props;

    this.state = {
      value: initial,
    };
  }

  setValue = (el) => {
    const { onChange, disabled } = this.props;

    if (!disabled) {
      this.setState({ value: el });
      onChange(el);
    }
  };

  render() {
    const { value } = this.state;
    const { children, className, disabled } = this.props;
    const { setValue } = this;

    const customClassName = classNames(
      'radio-button-group',
      '-buttons',
      className,
      {
        '-disabled': disabled,
      }
    );

    return (
      <Provider value={{ setValue, value }}>
        <div className={customClassName}>{children}</div>
      </Provider>
    );
  }
}

RadioButtonGroup.propTypes = {
  initial: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

RadioButtonGroup.defaultProps = {
  initial: undefined,
  onChange: () => {},
  className: '',
  children: undefined,
  disabled: false,
};

export default RadioButtonGroup;
